import { appURLs } from "@/app/app-urls.mjs";

export const WORK_SUITABILITIES = {
  cooling: {
    label: ["palworld:work.cooling", "Cooling"],
    src: `${appURLs.CDN_PLAIN}/palworld/img/UI/InGame/icon_palwork_10.webp`,
  },
  farming: {
    label: ["palworld:work.farming", "Farming"],
    src: `${appURLs.CDN_PLAIN}/palworld/img/UI/InGame/icon_palwork_12.webp`,
  },
  handiwork: {
    label: ["palworld:work.handiwork", "Handiwork"],
    src: `${appURLs.CDN_PLAIN}/palworld/img/UI/InGame/icon_palwork_04.webp`,
  },
  lumbering: {
    label: ["palworld:work.lumbering", "Lumbering"],
    src: `${appURLs.CDN_PLAIN}/palworld/img/UI/InGame/icon_palwork_06.webp`,
  },
  mining: {
    label: ["palworld:work.mining", "Mining"],
    src: `${appURLs.CDN_PLAIN}/palworld/img/UI/InGame/icon_palwork_07.webp`,
  },
  transporting: {
    label: ["palworld:work.transporting", "Transporting"],
    src: `${appURLs.CDN_PLAIN}/palworld/img/UI/InGame/icon_palwork_11.webp`,
  },
  generatingElectricity: {
    label: ["palworld:work.generatingElectricity", "Electricity"],
    src: `${appURLs.CDN_PLAIN}/palworld/img/UI/InGame/icon_palwork_03.webp`,
  },
  gathering: {
    label: ["palworld:work.gathering", "Gathering"],
    src: `${appURLs.CDN_PLAIN}/palworld/img/UI/InGame/icon_palwork_05.webp`,
  },
  kindling: {
    label: ["palworld:work.kindling", "Kindling"],
    src: `${appURLs.CDN_PLAIN}/palworld/img/UI/InGame/icon_palwork_00.webp`,
  },
  medicineProduction: {
    label: ["palworld:work.medicineProduction", "Medicine"],
    src: `${appURLs.CDN_PLAIN}/palworld/img/UI/InGame/icon_palwork_08.webp`,
  },
  planting: {
    label: ["palworld:work.planting", "Planting"],
    src: `${appURLs.CDN_PLAIN}/palworld/img/UI/InGame/icon_palwork_02.webp`,
  },
  watering: {
    label: ["palworld:work.watering", "Watering"],
    src: `${appURLs.CDN_PLAIN}/palworld/img/UI/InGame/icon_palwork_01.webp`,
  },
} as const;

export type WorkKind = keyof typeof WORK_SUITABILITIES;
